module.exports = __webpack_public_path__ + "img/jz_cjj_wx_2.ebc886dd.png";